import { Skeleton } from '@mui/material';
import PostDivWrapper from './component/PostDivWrapper';

const PostSkeleton = ({
  divWrapperClassName = '',
}: {
  divWrapperClassName?: string;
}) => {
  return (
    <PostDivWrapper
      widthClassname={`md:min-w-[calc(524px-28px)] min-w-[calc(100vw-28px)] w-auto self-stretch`}
      customClassname={`${divWrapperClassName}`}
    >
      <div className="flex flex-1 flex-col gap-4 px-2 pb-3 pt-2">
        <div className="flex gap-4">
          <Skeleton variant="circular" width={40} height={40} />
          <div className="flex flex-1 flex-col gap-1">
            <Skeleton variant="rounded" width={'90%'} height={28} />
            <Skeleton variant="rounded" width={'60%'} height={16.5} />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton variant="rounded" height={327} />
          <Skeleton variant="rounded" width={'100%'} height={60} />
          <Skeleton variant="rounded" width={'100%'} height={67} />
          <Skeleton variant="rounded" width={'20%'} height={20} />
        </div>
        <div className="flex flex-col">
          <Skeleton variant="rounded" width={'100%'} height={16} />
          <div className="my-3 h-[1px] w-full bg-[#E0E0E0]"></div>
          <div className="grid grid-cols-3 gap-x-2">
            <Skeleton variant="rounded" width={'100%'} height={32} />
            <Skeleton variant="rounded" width={'100%'} height={32} />
            <Skeleton variant="rounded" width={'100%'} height={32} />
          </div>
        </div>
      </div>
    </PostDivWrapper>
  );
};

export default PostSkeleton;
